

































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  assignUniqueInsightImages,
  imageForInsight,
  staticImageUrl,
} from '@/components/simpleSlide/insightImages';

interface InsightCard {
  id?: string;
  category?: string;
  question: string;
  imageUrl: string;
}

interface InsightRaw {
  id: string | undefined;
  category: string;
  question: string;
  imageKey: string;
  preferredImage: string | undefined;
}

@Component
export default class AiInsights extends Vue {
  @Prop() readonly subSlide!: any;

  get title(): string {
    return (this.subSlide && this.subSlide.title) || '';
  }

  get insights(): InsightCard[] {
    if (!this.subSlide || !Array.isArray(this.subSlide.insights)) {
      return [];
    }
    const raw: InsightRaw[] = this.subSlide.insights
      .map((item: any): InsightRaw | null => {
        if (!item) {
          return null;
        }
        if (typeof item === 'string') {
          if (!item) {
            return null;
          }
          return {
            id: undefined,
            category: '',
            question: item,
            imageKey: item,
            preferredImage: undefined,
          };
        }
        if (!item.question) {
          return null;
        }
        const slideText =
          item.slideQuestion || item.slide_question || item.question;
        return {
          id: item.id as string | undefined,
          category: item.category || '',
          question: slideText as string,
          imageKey: String(item.id || item.category || item.question || ''),
          preferredImage: item.image as string | undefined,
        };
      })
      .filter((item: InsightRaw | null): item is InsightRaw => !!item)
      .slice(0, 3);

    const images = assignUniqueInsightImages(
      raw.map((item: InsightRaw) => item.imageKey),
      raw.map((item: InsightRaw) => item.preferredImage),
    );

    return raw.map((item: InsightRaw, i: number) => ({
      id: item.id,
      category: item.category,
      question: item.question,
      imageUrl: staticImageUrl(images[i] || imageForInsight(item.imageKey)),
    }));
  }
}
